import { LandingTheme } from '@anm/api/modules/hosting';
import { media } from '@anm/styles/helpers';
import { landingCTAVariants, layoutVariants, textColorVariants } from '@anm/styles/landingThemeStyles';
import styled from 'styled-components';

type ItemWrapperProps = {
  variant: LandingTheme;
  playerColor: string;
};

type ButtonIconProps = {
  bgColor: string;
  variant: LandingTheme;
};

export const ListWrapper = styled.div`
  margin-bottom: 22px;
`;

const itemWrapperOnBiggerPhone = media.phone`
  width: 70px;
  height: 70px;
`;

export const ItemWrapper = styled.div<ItemWrapperProps>`
  position: relative;
  width: 75px;
  height: 75px;
  border: 1px solid rgba(1, 83, 130, 0.2);
  border-radius: 5px;
  ${({ variant }) => layoutVariants[variant]};
  ${({ variant }) => textColorVariants[variant]};

  ${itemWrapperOnBiggerPhone};

  svg {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;

    path {
      fill: currentColor;
    }
  }
`;

export const ButtonIcon = styled.div<ButtonIconProps>`
  width: 30px;
  height: 10px;
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;

  ${({ variant }) => landingCTAVariants[variant]};

  border-radius: 3px;
`;
